<div class="container d-flex justify-content-center align-items-center" style="min-height: 60vh;">
	<div class="card shadow p-4" style="width: 100%; max-width: 460px; border-radius: 1rem;">
		<div class="text-center mb-4">
			<h4 class="fw-bold mb-5">Restablecer contraseña</h4>

		  	<form-steps 
				[pasos]="pasos" 
				[pasoActual]="pasoActual"
				[puedeAvanzar]="puedeAvanzar"
				(cambioPaso)="actualizarPaso($event)"
				*ngIf="tokenValido">
				<div class="container mt-3" *ngIf="pasoActual === 1">
					<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
					    <!-- Password -->
					    <div class="mb-3">
					      <label class="form-label">Nueva contraseña</label>
					      <div class="input-group">
					        <input 
					          [type]="showPassword ? 'text' : 'password'" 
					          class="form-control" 
					          formControlName="password" 
					          placeholder="Ingresa tu nueva contraseña"
					          [(ngModel)]="password">
					        <button type="button" class="btn btn-outline-secondary" (click)="togglePassword()">
					          <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
					        </button>
					      </div>
					      <div *ngIf="formControl('password')?.touched && formControl('password')?.invalid">
					        <small class="text-danger">Mínimo 8 caracteres, debe incluir letras y números</small>
					      </div>
					    </div>

					    <!-- Confirm Password -->
					    <div class="mb-4">
					      <label class="form-label">Confirmar contraseña</label>
					      <div class="input-group">
					        <input 
					          [type]="showConfirmPassword ? 'text' : 'password'" 
					          class="form-control" 
					          formControlName="confirmPassword" 
					          placeholder="Repite tu contraseña">
					        <button type="button" class="btn btn-outline-secondary" (click)="toggleConfirmPassword()">
					          <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
					        </button>
					      </div>
					      <div *ngIf="resetPasswordForm.errors?.['noCoinciden'] && (formControl('confirmPassword')?.touched || formControl('password')?.touched)">
					        <small class="text-danger">Las contraseñas no coinciden</small>
					      </div>
					    </div>
					</form>
				</div> <!-- /END pasoActual 2 -->


				<div class="container mt-3" *ngIf="pasoActual === 2">
					<div class="alert alert-success d-flex align-items-center gap-2 shadow-sm rounded-3 p-3" role="alert" *ngIf="actualizacionPassword">
					  <i class="bi bi-check-circle-fill fs-4 text-success"></i>
					  <div>
					    <strong>¡Éxito!</strong> Tu contraseña se ha actualizado correctamente.
					  </div>
					</div>

					<div class="alert alert-danger d-flex align-items-center gap-2 shadow-sm rounded-3 p-3" role="alert" *ngIf="!actualizacionPassword">
					  <i class="bi bi-x-circle-fill fs-4 text-danger"></i>
					  <div>
					    <strong>¡Error!</strong> Ocurrió un problema al actualizar tu contraseña. Intenta nuevamente más tarde.
					  </div>
					</div>


				</div> <!-- /END pasoActual 2 -->
			</form-steps>

			<div class="alert alert-warning border-0 shadow-sm d-flex align-items-center gap-2 p-3 rounded-3" role="alert" *ngIf="!tokenValido">
			  <i class="bi bi-clock-history fs-4 text-warning"></i>
			  <div>
			    <strong>¡Atención!</strong> La solicitud para cambiar tu contraseña ha caducado.<br>
			    Por favor, vuelve a solicitar un nuevo enlace.
			  </div>
			</div>
		</div>
	</div>
</div>
